import { Environment } from '@/constants/common';

export function transformEnvironment(environment: string | null) : Environment {
  switch (environment) {
    case 'prod': {
      return Environment.Production;
    }

    case 'stage': {
      return Environment.Stage;
    }

    case 'dukenukem': {
      return Environment.Dukenukem;
    }

    default: {
      return Environment.Development;
    }
  }
}

export function forceEnvironment(newEnvironment: string) : void {
  localStorage.setItem('environment', newEnvironment);

  location.reload();
}

export function resetEnvironment() : void {
  localStorage.removeItem('environment');

  location.reload();
}

export function getForcedEnvironment() : Environment | undefined {
  const possibleEnvironment = localStorage.getItem('environment');

  if (possibleEnvironment === null) {
    return undefined;
  }

  return transformEnvironment(possibleEnvironment);
}

export function getRealEnvironment() : Environment {
  switch (window.location.hostname) {
    case 'booking.bobw.co':
    case 'bobw.co': {
      return Environment.Production;
    }

    case 'booking.staging-bobw.com':
    case 'bobw.webflow.io':
    case 'preview.bobw.co':
    case 'bobw.netcprev.co.uk': {
      return Environment.Stage;
    }

    case 'booking.dukenukem.test-bobw.com': {
      return Environment.Dukenukem;
    }

    default: {
      return Environment.Development;
    }
  }
}

export function getIsProductionEnvironment() : boolean {
  return getRealEnvironment() === Environment.Production;
}

export function getIsStageEnvironment() : boolean {
  return getRealEnvironment() === Environment.Stage;
}

export function getIsDevelopmentEnvironment() : boolean {
  return getRealEnvironment() === Environment.Development;
}

export function getEnvironment() : Environment {
  const realEnvironment = getRealEnvironment();

  // Always use production environment in production
  if (realEnvironment === Environment.Production) {
    return realEnvironment;
  }

  return getForcedEnvironment() ?? realEnvironment;
}
